const { Urls } = window;

export { Urls };
